<template>
    <div id="modal-apply-tech-menu" class="modal fade">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body">
                    <ul class="list-group list-group-flush">
                        <li class="list-group-item border-0" @click="openPricePub">
                            <div class="row">
                                <div class="col-2 pr-0 text-center">
                                    <i class="text-muted fas fa-comments-dollar icon-size"></i>
                                </div>
                                <div class="col pl-2">
                                    <span class="pl-2">
                                        公開単価 
                                        <span v-if="item.price_pub == '1'" class="text-danger"> (未設定) </span>
                                        <span v-if="item.price_pub == '0'" class="text-success"> (設定済み) </span>
                                    </span>
                                </div>
                            </div>
                        </li>
                        <li class="list-group-item border-0" @click="openNamePub">
                            <div class="row">
                                <div class="col-2 pr-0 text-center">
                                    <i class="text-muted fas fa-comments-dollar icon-size"></i>
                                </div>
                                <div class="col pl-2">
                                    <span class="pl-2">
                                        氏名公開 
                                        <span v-if="item.name_pub == '1'" class="text-danger"> (未公開) </span>
                                        <span v-if="item.name_pub == '0'" class="text-success"> (公開済み) </span>
                                    </span>
                                </div>
                            </div>
                        </li>
                        <template v-if="key == 'intv'">
                            <li v-if="item.in_flg == '0' || item.in_flg == '4' || item.in_flg == 'x'" class="list-group-item border-0" @click="cancelIntv">
                                <div class="row">
                                    <div class="col-2 pr-0 text-center">
                                        <i class="text-muted fas fa-comments-dollar icon-size"></i>
                                    </div>
                                    <div class="col pl-2">
                                        <span class="pl-2">
                                            面接取消 
                                            <span v-if="item.in_flg == 'x'" class="text-danger">(取消済み)</span>
                                            <span v-else class="text-success">(開催中)</span>
                                        </span>
                                    </div>
                                </div>
                            </li>
                        </template>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        data () {
            return {
                item: {},
                key: ""
            }
        },
        methods: {
            openThis (item, key) {
                this.resetThis()
                this.item = item
                this.key = key
                $('#modal-apply-tech-menu').modal('show')
            },
            hideThis () {
                this.resetThis()
                $('#modal-apply-tech-menu').modal('hide')
            },
            resetThis () {
                this.item = {}
            },
            openPricePub () {
                this.$parent.openPricePub(this.item)
                this.hideThis()
            },
            openNamePub () {
                this.$parent.openNamePub(this.item)
                this.hideThis()
            },
            cancelIntv () {
                this.$parent.cancelIntv(this.item)
                this.hideThis()
            }
        }
    }
</script>

<style>

</style>
